<div class="header-container">
  <div class="logo-container" style="width: 180px">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" ><img class="home-logo" src="assets/images/logo.png"></a>
  </div>
  <b class="mr-3">
    {{CompanyName}}
  </b>
  <nb-select *ngIf="upSelect" disabled
      [selected]="selectORG_Store_ID" (selectedChange)="selectStoreChange($event)" status="primary">
    <nb-option *ngFor="let theme of storeSelectList" [value]="theme.value"> {{ theme.content }}</nb-option>
  </nb-select>
  <nb-select  *ngIf="!upSelect" disabled
      [selected]="selectORG_Store_ID" (selectedChange)="selectStoreChange($event)" status="primary">
    <nb-option *ngFor="let theme of storeSelectList" [value]="theme.value"> {{ theme.content }}</nb-option>
  </nb-select>

  <!-- 隱藏 -->
  <!-- <nb-select [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
    <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
  </nb-select>
  -->
</div>

<div class="header-container">
  <nb-actions size="small">

    <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action>
    <nb-action class="control-item" icon="email-outline"></nb-action>
    <nb-action class="control-item" icon="bell-outline"></nb-action> -->
    <nb-action class="user-action" *nbIsGranted="['view', 'user']">
    
      <nb-user [nbContextMenu]="userMenu" [onlyPicture]="userPictureOnly" [name]="user?.name"
        [picture]="user?.picture">
      </nb-user>
    </nb-action>
  </nb-actions>
</div>